// LIBRARIES
import styled, { css } from "styled-components";
import CancelIcon from "@mui/icons-material/Cancel";
import { CircularProgress } from "@mui/material";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const ModalContainer = styled.div`
  height: 100%;
  width: 800px;
  // width: 90%;
  height: 100%;
  justify-content: center;
  border-bottom-left-radius: 24px;
  border-top-left-radius: 24px;
  background-color: #F5F5F5;
  position: absolute;
  right: 0%;
  display: flex;
  flex-direction: column;
  outline: none;
  padding: 80px;
  @media screen and (max-width: 830px) {
    width: 100%;
    padding: 20px;
  }
`;

export const LoadingModalContainer = styled.div`
height: 100%;
width: 800px;
// width: 90%;
height: 100%;
justify-content: center;
align-items: center;
border-bottom-left-radius: 24px;
border-top-left-radius: 24px;
background-color: #F5F5F5;
position: absolute;
right: 0%;
display: flex;
flex-direction: column;
outline: none;
padding: 80px;
@media screen and (max-width: 830px) {
  width: 100%;
}
`;

export const LodingSign = styled(CircularProgress)`
  && {
    justify-content: center;
    align-items: center;
    color: ${COLORS.rainbowIndigo};
    opacity: 1 !important;
  }
`;

export const CloseIconContainer = styled.div`
  position: absolute;
  left: 20px;
  top: 20px;
`;

export const CloseIcon = styled(CancelIcon)`
  && {
    color: ${COLORS.thirdGray};
    padding: 0;
    margin-bottom: 0;
    cursor: pointer;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ModalTitle = styled.div`
  @media screen and (max-height: 830px) {
    font-size: 20px;
  }
  @media screen and (min-height: 831px) {
    font-size: 30px;
  }
  font-family: ${FONTS.newsharp};
  color: ${COLORS.rainbowIndigo};
`;

export const ModalSubtitle = styled.div`
  @media screen and (max-height: 830px) {
    font-size: 18px;
  }
  @media screen and (min-height: 831px) {
    font-size: 22px;
  }
  font-family: ${FONTS.montserrat};
  font-weight: 600;
  color: ${COLORS.primaryGray};
  margin-bottom: 10px;
`;

export const UserInfoWrapper = styled.div`
  @media screen and (max-height: 830px) {
    margin: 30px 0 0 60px;
  }
  @media screen and (min-height: 831px) {
    margin: 50px 0 0 60px;
  }
  display: flex;
  flex-direction: row;
  align-items: center;
  // justify-content: space-between;
  // width: 100%;
`;

export const ButtonContainer = styled.div`
  margin-left: auto;
  margin-right: 50px;
  @media (max-width: 570px) {
    width: 200px;
  }
`

export const UserImage = styled.img`
  @media screen and (max-height: 830px) {
    width: 50px;
    height: 50px;
  }
  @media screen and (min-height: 831px) {
    width: 60px;
    height: 60px;
  }
  border-radius: 50%;
  background-color: ${COLORS.backgroundColor};
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-right: 20px;
`;

export const UserName = styled.div`
  @media screen and (max-height: 830px) {
    font-size: 18px;
  }
  @media screen and (min-height: 831px) {
    font-size: 20px;
  }
  @media (max-width: 570px) {
    font-size: 16px;
  }
  font-weight: bold;
  color: ${COLORS.secondaryBlack};
  font-family: ${FONTS.newsharp};
`;

export const UserStatus = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${FONTS.montserrat};
`;

export const Dot = styled.div(
  ({ color }) => css`
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: ${color ? color : "transparent"};
  `
);

export const StatusValue = styled.div(
  ({ color }) => css`
    color: ${color ? color : "transparent"};
    margin-left: 10px;
    font-size: 14px;
  `
);

export const RentalInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 9px 60px 20px 60px;
`;

export const LeftSideWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RentalInfoLine = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
`;

export const RentalInfoLabel = styled.div`
  font-size: 18px;
  font-family: ${FONTS.newsharp};
  @media (max-width: 570px) {
    font-size: 14px;
  }
`;

export const RentalInfoValue = styled.div`
  font-size: 18px;
  font-family: ${FONTS.newsharp};
  margin-left: 10px;
  @media (max-width: 570px) {
    font-size: 14px;
  }
`;

export const RentalStatusInfoValue = styled.div`
  font-size: 12px;
  font-family: ${FONTS.montserrat};
  margin-left: 10px;
  margin-top: 3px;
`;

export const RightSideWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EquipmentInfoWrapper = styled.div`
  margin: 0 60px 0 60px;
  display: flex;
  flex-direction: column;
`;

export const EquipmentInfoTitle = styled.div`
  font-size: 18px;
  font-family: ${FONTS.montserrat};
  font-weight: bold;
  margin-top: 10px;
  @media (max-width: 570px) {
    font-size: 14px;
  }
`;

export const EquipmentInfoLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
`;

export const EquipmentReportIcon = styled.img`
  width: 12px;
  height: 12px;
  margin-right: 10px;
`;

export const EquipmentUserReport = styled.div`
  font-size: 16px;
  font-family: ${FONTS.montserrat};
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 600;
  color: ${COLORS.rainbowIndigo};
`;

export const EquipmentHasReportUserReport = styled.div`
  font-size: 16px;
  font-family: ${FONTS.montserrat};
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 600;
  color: ${COLORS.terraCotta};
`;

export const SeeEquipmentReport = styled.div`
  font-size: 14px;
  text-decoration: underline;
  font-family: ${FONTS.newsharp};
  cursor: pointer;
  color: ${COLORS.cornflowerBlue};
`;

export const PhotoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin: 0 60px;
`;

export const Photo = styled.img`
  margin-top: 20px;
  width: 145px;
  height: 145px;
  object-fit: contain;
  cursor: pointer;
`;

export const PhotosContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-bottom: 30px;
  width: 100%;
`;

export const RentalLogsContainer = styled.div`
  display: flex;
  flex-direction: column;
  // margin: 0 60px 0 60px;
`;
export const RentalLogsTitle = styled.text`
  font-size: 20px;
  font-weight: bold;
  font-family: ${FONTS.montserrat};
  margin-bottom: 20px;
  @media (max-width: 570px) {
    font-size: 18px;
  }
`;
export const RentalLogsContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 150px;
  padding-right: 10px;
  overflow: hidden;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${COLORS.backgroundColor};
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      180deg,
      ${COLORS.rainbowIndigo} 0%,
      ${COLORS.rainbowIndigo} 100%
    );
    border-radius: 10px;
  }
`;
export const RentalLogsContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${COLORS.secondaryBlack};
  width: 100%;
  font-family: ${FONTS.montserrat};
  font-weight: 600;
`;

export const RentalLogDetail = styled.text`
  font-size: 18px;
  @media (max-width: 570px) {
    font-size: 14px;
  }
`;

export const Bar = styled.div`
  padding: 1px;
  background-color: ${COLORS.backgroundColor};
  margin: 10px 0;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  
`;

export const IconContainer = styled.div`
  width: 56px;
  height: 56px;
  background-color: #293462;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Icon = styled.img`

`;



export const ContentInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
`;

export const Title = styled.div`
font-size: 20px;
color: ${COLORS.primaryAppBlack};
font-family: ${FONTS.poppins};
letter-spacing: 0.8px;
font-weight: 600;
`;

export const Subtitle = styled.div`
font-size: 16px;
color: #B6B7BF;
font-family: ${FONTS.poppins};
letter-spacing: 0.64px;
font-weight: medium;
`;